import React from "react";
import styled from "styled-components";

import ProfileButtonComponent from './ProfileButtonComponent';
import ProfileDropdown from "./ProfileDropdown";

import logo from "../../assets/cat_logo.svg";

const Nav = styled.div`
  /* background-image: url(banner); */
  padding: 12px 120px;
  padding-bottom: 0px;
  flex-direction: column;
  justify-content: space-between;
  display: none;
  @media (min-device-width: 481px) {
  display: flex;
  }
`;

const HorizontalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Username = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: bold;
  font-size: 80px;
`;

const Tab = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-size: 18px;
  padding-bottom: 20px;
`;



export default function NFTNavDesktop(props:any){
    
    return (
        <>
	    {/* <Nav style={{background: `url('${banner}')`}}> */}
	    <Nav>
	        <HorizontalWrapper style={{justifyContent: 'space-between'}}>
	            <HorizontalWrapper>
	                <a href="https://glip.gg/" >
	                    <img style={{width: 36, height: 36}} src={logo} />
	                </a>
                        <a href="https://glip.gg/" className={'hover'}>
	                    <label style={{ marginLeft: 16, fontFamily: "'Space Mono', monospace", fontSize: 20, fontWeight: 700 }}>
	                        !glip
	                    </label>
	                </a>                
	            </HorizontalWrapper>
	            <HorizontalWrapper>
                        
	            </HorizontalWrapper>
	            <HorizontalWrapper>
                        
                        <a
	                    target="_blank"
	                    style={{ opacity: 0.5, marginLeft: 32, marginRight: 32, fontSize: 14, fontWeight: 'bold', fontFamily: 'Space Mono' }}
	                    href={
	                    "https://glip.gg/"
	                    }
	                >
	                    FOR CREATORS
	                </a>
	                <a
	                    target="_blank"
	                    style={{ opacity: 0.5, marginRight: 32, fontSize: 14, fontWeight: 'bold', fontFamily: 'Space Mono' }}
	                    href={
	                    "https://discord.gg/3KqyT6Js7r"
	                    }
	                >
	                    DISCORD
	                </a>
	                {props.connected && (
	                    <a onClick={() => {
                                window.analytics.track('mynfts_clicked', {
                                    type: 'web',
                                    from: 'navbar'
                                });
                            }} href={`/address/${props.user.username}`} style={{ opacity: 0.5, marginRight: 32, fontSize: 14, fontWeight: 'bold', fontFamily: 'Space Mono' }}>PROFILE</a>
                        )}
	                <ProfileButtonComponent
                            connected={props.connected}
                            user={props.user}
                            setShowModal={props.setShowModal}
                        >
	                </ProfileButtonComponent>
	                
	            </HorizontalWrapper>
	        </HorizontalWrapper>
	        {props.expanded && <>
	            <div style={{display: 'flex', justifyContent: 'center', alignContent: 'center'}}>
                        <Username>{props.creator}</Username>
	            </div>


	            <div style={{display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: 43}}>
		        {props.showTabs ? <>
		            <Tab
			        className={'hover'}
			        onClick={() => changeTab('NFT')}
			        style={{
			            color: props.active == 'NFT'? '#fff' : 'rgba(255,255,255,0.5)',
			            borderBottom: props.active == 'NFT'? '2px solid #FFFFFF' : '2px solid transparent',
			            marginRight: 54,
			            fontWeight: 600
			        }}
		            >NFT
			    </Tab>
		            <Tab
			        className={'hover'}
			        onClick={() => props.changeTab('collection')}
			        style={{
			            color: props.active == 'collection' ? '#fff' : 'rgba(255,255,255,0.5)',
			            borderBottom: props.active == 'collection'? '2px solid #FFFFFF' : '2px solid transparent',
			            fontWeight: 600
			        }}
		            >COLLECTORS
			    </Tab>
		        </>
		        : props.ownedTab &&
		         <>
		             {/* <Tab
			         className={'hover'}
			         style={{
			         color: props.active == 'NFT'? '#fff' : 'rgba(255,255,255,0.5)',
			         borderBottom: '2px solid transparent',
			         marginRight: 54,
			         fontWeight: 600
			         }}
		                 >OWNED
		                 </Tab> */}
		         </>
		        }
	            </div>
	        </>}
	        
	    </Nav>
            <ProfileDropdown
                user={props.user}
                openAddPaymentsDiv={()=>{props.openAddPaymentsDiv()}}
                setAddSocialModalOpen={
                ()=>{props.setAddSocialModalOpen(true)}}
	        address={props.address}
	        smallAddress={props.accString}
	        open={props.showModal}/>
            {props.showModal && (
                <div
		    onClick={() => props.setShowModal(false)}
		    style={{
			position: "fixed",
			top: 0,
			bottom: 0,
			left: 0,
			right: 0,
			background: "transparent",
		    }}
		></div>
            )}
        </>
    );
}
